import { Button, Modal } from "flowbite-react";
import QueryReTable from "../components/QueryReTable";
import { useUserServices } from "../context/DealerProfile";
import ChangeRequestList from "../features/Changerequest/ChangeRequestList";
import OrderLists from "../features/order/OrderLists";
import useQueryTable from "../hooks/useQueryTable";
import { useState } from "react";
import ChangeRequestForm from "../features/Changerequest/ChangeRequestForm";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const ChangeRequestPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  // Fetch Data Api
  const {
    dealerDetail: { accountName },
  } = useUserServices();
  const [isLoading, data, searchValues, setSearchValues, moreData, totalData] =
    useQueryTable({
      queryList: ["page", "Stage"],
      // url: "/server/dealer_backend/order-history/" + crmUserDetail?.dealer?.id,
      url: `/server/dealer_backend/fetchRequestList/${accountName?.id}`,
    });

  const {
    data: { data: ChangeRequest },
  } = data ?? { data: { data: [] } };

  //   Post Data Api
  const [formData, setFormData] = useState({
    Account_id: accountName.name,
    selectedValues: [],
    remarks: "",
  });
  const [errors, setErrors] = useState({});

  const handleAddBillingAddressClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  // Handle form changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Display a loading toast while processing the request
    const toastLoading = toast.loading("Creating Request Change...");

    // Validation logic
    const validationErrors = {};
    if (!formData.Account_id) {
      validationErrors.Account_id = "Channel Partner is required.";
    }
    if (!formData.selectedValues.length) {
      validationErrors.selectedValues = "Please select at least one option.";
    }
    if (!formData.remarks) {
      validationErrors.remarks = "Remarks are required.";
    }

    // If there are validation errors, set them and exit early
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.dismiss(toastLoading); // Dismiss the loading toast
      return;
    }

    // Prepare the data for the API request
    const apiData = {
      Channel_Partner: accountName.id,
      Request_details: formData.remarks,
      Request_For: formData.selectedValues,
      Status: "Pending for Approval",
    };

    try {
      // Send the API request
      const response = await fetch("/server/dealer_backend/createRequest", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(apiData),
      });

      // Parse the response JSON
      const responseData = await response.json();

      // Handle non-OK responses
      if (!response.ok) {
        toast.error(
          responseData.message || "Failed to create request. Please try again.",
          {
            id: toastLoading,
          }
        );
        return;
      }

      // Success toast and close modal
      toast.success("Request created successfully!", { id: toastLoading });
      setIsModalOpen(false);
      setFormData({
        Account_id: accountName.name,
        selectedValues: [],
        remarks: "",
      });
      // Redirect to the desired URL
      navigate("/change-request?page=1");
    } catch (error) {
      // Handle network or unexpected errors
      console.error("Error creating request:", error);
      toast.error("An unexpected error occurred. Please try again later.", {
        id: toastLoading,
      });
    } finally {
      // Always dismiss the loading toast
      toast.dismiss(toastLoading);
    }
  };

  return (
    <>
      <div className="flex justify-between my-4">
        <h2 className="text-2xl font-bold text-gray-700">Change Request</h2>

        <Button onClick={handleAddBillingAddressClick}>
          Create Change Request
        </Button>
      </div>
      <QueryReTable
        moreData={moreData}
        totalData={totalData}
        searchValues={searchValues}
        setSearchValues={setSearchValues}
      >
        <ChangeRequestList
          isLoading={isLoading}
          setSearchValues={setSearchValues}
          orders={ChangeRequest}
          key={"something"}
        />
      </QueryReTable>

      {/* Modal for Adding Billing Address */}
      <Modal show={isModalOpen} onClose={handleModalClose}>
        <Modal.Header>Change Request</Modal.Header>
        <Modal.Body>
          <ChangeRequestForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ChangeRequestPage;
